import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';

import { OrganizationService } from '../api';
import { RedirectMfaComponent } from './redirect-mfa/redirect-mfa.component';
import { LoadingMfaComponent } from './redirect-mfa/components/loading-mfa/loading-mfa.component';

@NgModule({
  declarations: [LoginComponent, RedirectMfaComponent, LoadingMfaComponent],
  imports: [
    SharedModule,
    LoginRoutingModule,
  ],
  providers: [OrganizationService]
})
export class LoginModule { }
